import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Col, Dialog,  InputField, Row, Typography } from "../../ppui";
import {
  ContentHeading,
  ContentLayout,
  ContentWrapper,
  ContentMenu,
  ContentForm,
} from "../style";
import { Outlet } from "react-router-dom";
import { List, ListIcon, ListItem, ListText } from "../../ppui/list";
import { RiExchangeFundsLine, RiProfileLine } from "react-icons/ri";
import { HiOutlineOfficeBuilding } from "react-icons/hi";
import { MdOutlineDocumentScanner } from "react-icons/md";
import { LuUserSquare2 } from "react-icons/lu";
import { AiOutlineBank } from "react-icons/ai";
import { GrCompliance } from "react-icons/gr";

function StatutoryDetails() {
  const [open, setOpen] = React.useState(false);
  const handleClose = () => setOpen(false);

  const navigate = useNavigate();
  const location = useLocation();
  const menuItems = [
    {
      icon: <RiProfileLine />,
      primaryText: "EPF",
      path: "/statutory-details/epf",
    },
    {
      icon: <LuUserSquare2 />,
      primaryText: "ESI",
      path: "/statutory-details/esi",
    },
    {
      icon: <HiOutlineOfficeBuilding />,
      primaryText: "Gratuity ACT",
      path: "/statutory-details/gratuity-act",
    },
    {
      icon: <MdOutlineDocumentScanner />,
      primaryText: "P-Tax Status",
      path: "/statutory-details/p-tax-status",
    },
    {
      icon: <RiExchangeFundsLine />,
      primaryText: "Labour Welfare Fund",
      path: "/statutory-details/labour-welfare-fund",
    },
    {
      icon: <GrCompliance />,
      primaryText: "Compliance Information",
      path: "/statutory-details/compliance",
    },
    {
      icon: <AiOutlineBank />,
      primaryText: "Banking And Finance",
      path: "/statutory-details/banking-and-finance",
    },
  ];

  return (
    <>
      <ContentLayout>
        <ContentHeading>
          <Typography variant="h5" mb="0">
            Statutory Details
          </Typography>
        </ContentHeading>

        <ContentWrapper>
          <ContentMenu>
            <List
              size={"md"}
              color={"default"}
              activeColor={"success"}
              Colorvariant={"dark"}
              hover={"secondary"}
              gap={15}
            >
              {menuItems.map((item, index) => (
                <ListItem
                  key={index}
                  onClick={() => navigate(item.path)}
                  className={location.pathname === item.path ? "active" : ""}
                >
                  <ListIcon>{item.icon}</ListIcon>
                  <ListText primary={item.primaryText} />
                </ListItem>
              ))}
            </List>
          </ContentMenu>
          <ContentForm>
            <Outlet />
          </ContentForm>
        </ContentWrapper>
      </ContentLayout>

      {/* Profile-Header-Modal */}
      <Dialog
        title="Basic Information"
        closeButton={true}
        fullWidth
        maxWidth="xs"
        open={open}
        buttonName={"Update"}
        onClose={handleClose}
        onSubmit={() => alert("Submitted")}
        separator
      >
        <Row rowGap>
          <Col xs={12}>
            <InputField
              fullWidth
              label="Phone"
              placeholder="Type Here..."
              type="number"
              required
            />
          </Col>
          <Col xs={12}>
            <InputField
              fullWidth
              label="Landline"
              placeholder="Type Here..."
              type="number"
              required
            />
          </Col>
          <Col xs={12}>
            <InputField
              fullWidth
              label="Email"
              placeholder="Type Here..."
              type="number"
              required
            />
          </Col>
        </Row>
      </Dialog>
      {/* Profile-Header-Modal */}
    </>
  );
}

export default StatutoryDetails;
